
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/summerblackfriday2606/roulette-event",
      function () {
        return require("private-next-pages/event/summerblackfriday2606/roulette-event/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/summerblackfriday2606/roulette-event"])
      });
    }
  